import React from 'react';
import 'partial/FeaturedAd/FeaturedAdView.scss';
import { InfoCircleOutlined } from '@ant-design/icons';
import CreditCardOfferHolder from 'partial/OfferManager/holder/CreditCardOfferHolder';
import PersonalLoanOfferHolder from 'partial/OfferManager/holder/PersonalLoanOfferHolder';
import CreditRepairOfferHolder from 'partial/OfferManager/holder/CreditRepairOfferHolder';
import { Button } from 'components/form/Button/Button';
import { DEFAULT_TC_TEXT } from 'helpers/offer.helpers';
import { Tag } from 'components/Tag';
import { ReactComponent as OpenInNew } from 'style/_assets/icons/open-in-new.svg';
import Label from 'components/form/Label/Label';
import classnames from 'classnames';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { CSTooltip } from 'components/Tooltip/CSToolTip';
import SectionContainer from 'components/Containers/SectionContainer';
import { ReactComponent as LockIcon } from 'style/_assets/icons/lock-white.svg';
import AutoLoanOfferHolder from 'partial/OfferManager/holder/AutoLoanOfferHolder';

const TitleSubtitleContainer = ({ title, subtitle, tooltip }) => {
  return (
    <div className="FlexContainer flex-column">
      <div className="flex-container align-items-center m-items-align-start">
        <div
          className="Subtitle-1 margB6 m-margT12 m-margB16"
          dangerouslySetInnerHTML={{
            __html: title,
          }}
        />
        {tooltip && (
          <CSTooltip
            tooltipContent={
              <div
                dangerouslySetInnerHTML={{
                  __html: tooltip,
                }}
              />
            }
          >
            <InfoCircleOutlined />
          </CSTooltip>
        )}
      </div>

      <div
        className="Body-2 t-text-12 m-margB24 bulletpoint-style"
        dangerouslySetInnerHTML={{
          __html: subtitle,
        }}
      />
    </div>
  );
};

function TermsContainer({ offerMetadata, clickTcHandler }) {
  if (offerMetadata.tcUrl) {
    return (
      <div
        className="tcBlock Body-2 margT8 m-margT10 mMargB8 mtext-center"
        onClick={clickTcHandler}
      >
        <>
          <span className="tcText otherLink link-style">
            {offerMetadata.tcText || DEFAULT_TC_TEXT}
          </span>{' '}
          <OpenInNew height="14" width="14" />
        </>
      </div>
    );
  }
  return <div className="m-margT10 mMargB8"></div>;
}

const FeaturedAdTemplate = ({
  offerMetadata,
  offerImageLinkUrlProxy,
  customClass,
  clickApplyImageHandler,
  clickApplyHandler,
  seenPixel,
  hideAdTag,
  tagText,
  ...props
}) => {
  const clickImageHandler =
    offerMetadata.offerType === 'PERSONAL_LOAN'
      ? clickApplyHandler
      : clickApplyImageHandler;
  let imageClass = 'featureAdImage';

  if (offerMetadata.offerType === 'CREDIT_CARD') {
    imageClass = 'featureAdCCImage';
  }
  const hideApplyLabelForSecuredAds =
    !hideAdTag && !offerMetadata.applyNowLabelFlag;
  const innerPadClass = classnames({
    'padLR24 m-pad0': !hideAdTag,
  });

  const adTagText = tagText ? tagText : 'FEATURED';

  return (
    <SectionContainer className={`featuredAd ${customClass}`}>
      <div className="featuredAdContainer padLR24 m-padLR16">
        <div className="FlexContainer flex-column">
          {!hideAdTag && (
            <div className="format100 margB16">
              <Tag backgroundClass="bgYellow075">{adTagText}</Tag>
            </div>
          )}
          <div
            className={`FlexContainer t-flex-column t-flex-align-center ${innerPadClass}`}
          >
            {hideAdTag && <div className="pad4"></div>}
            <div
              className={`justify-center imageContainer FlexContainer flex-column margR24 m-margr0`}
            >
              <div className="imageInner">
                {seenPixel}
                <img
                  className={`${imageClass} mfcenterFit mblock link`}
                  onClick={clickImageHandler}
                  alt="Credit card"
                  src={offerImageLinkUrlProxy}
                />
              </div>
              <TermsContainer offerMetadata={offerMetadata} {...props} />
            </div>
            <div className="FlexContainer flex-column">
              <div className="FlexContainer t-flex-column height100 items-align-center">
                <div className="FlexContainer flex-column textContainer margR24 m-margr0">
                  <div className="mobileHide">
                    <TitleSubtitleContainer
                      title={offerMetadata.adTitleWeb}
                      subtitle={offerMetadata.adSubTitleWeb}
                      tooltip={offerMetadata.tooltip}
                    />
                  </div>
                  <div className="desktopHide">
                    <TitleSubtitleContainer
                      title={offerMetadata.adTitleMobile}
                      subtitle={offerMetadata.adSubTitleMobile}
                      tooltip={offerMetadata.tooltip}
                    />
                  </div>
                </div>
                <div
                  className={`buttonContainer FlexContainer flex-column t-Width100`}
                >
                  <Button
                    mrphType="primary"
                    onClick={clickApplyHandler}
                    className="applyNowButton format100 m-margB0"
                  >
                    <FlexContainer className="justify-center align-items-center">
                      <LockIcon className="lockIcon pos-rel" />
                      <Label type="Subtitle-2 primary_cta_text_light">
                        {offerMetadata.buttonCopy}
                      </Label>
                    </FlexContainer>
                  </Button>
                  {offerMetadata.applyNowLabelFlag && (
                    <div
                      className="buttonLabel lineHeight-1-33 text-center text-12 fontGray300 margT8 m-margT6"
                      dangerouslySetInnerHTML={{
                        __html: offerMetadata.applyNowLabelText,
                      }}
                    ></div>
                  )}
                  {hideApplyLabelForSecuredAds && (
                    <div className="padB24 m-padB0"></div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SectionContainer>
  );
};

const FeaturedAdView = ({
  featuredAdOffer,
  customClass,
  eventHandler,
  offerPosition,
  modulePosition,
  ...props
}) => {
  const finalOfferPosition = offerPosition ? offerPosition : null;
  const pagePosition = 'Featured Ad';
  if (featuredAdOffer?.offerType === 'PERSONAL_LOAN') {
    return (
      <PersonalLoanOfferHolder
        {...props}
        personalLoanTemplate={FeaturedAdTemplate}
        offerMetadata={featuredAdOffer}
        eventHandler={eventHandler}
        customClass={customClass}
        pagePosition={pagePosition}
        position={finalOfferPosition}
        modulePosition={modulePosition}
      />
    );
  } else if (featuredAdOffer?.offerType === 'CREDIT_CARD') {
    return (
      <CreditCardOfferHolder
        {...props}
        creditCardTemplate={FeaturedAdTemplate}
        offerMetadata={featuredAdOffer}
        eventHandler={eventHandler}
        customClass={customClass}
        pagePosition={pagePosition}
        position={finalOfferPosition}
        modulePosition={modulePosition}
      />
    );
  } else if (featuredAdOffer?.offerType === 'CREDIT_REPAIR') {
    return (
      <CreditRepairOfferHolder
        {...props}
        creditRepairTemplate={FeaturedAdTemplate}
        offerMetadata={featuredAdOffer}
        eventHandler={eventHandler}
        customClass={customClass}
        pagePosition={pagePosition}
        position={finalOfferPosition}
        modulePosition={modulePosition}
      />
    );
  } else if (featuredAdOffer.offerType === 'AUTO_LOAN') {
    return (
      <AutoLoanOfferHolder
        {...props}
        autoLoanTemplate={FeaturedAdTemplate}
        offerMetadata={featuredAdOffer}
        eventHandler={eventHandler}
        pagePosition={pagePosition}
        position={finalOfferPosition}
        modulePosition={modulePosition}
      />
    );
  } else {
    return null;
  }
};

export default FeaturedAdView;
